import { render, staticRenderFns } from "./Job_Premedia.vue?vue&type=template&id=02b264d4&"
import script from "./Job_Premedia.vue?vue&type=script&lang=js&"
export * from "./Job_Premedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports